<template>
  <footer class="blog-footer">
    <div class="footer-inner">
      <div class="footer-brand">Wbxsb Blog</div>
      <p class="footer-desc">记录技术 · 分享思考 · 沉淀成长</p>
      <div class="footer-nav">
        <router-link to="/">首页</router-link>
        <router-link to="/tags">标签</router-link>
        <router-link to="/projects">项目</router-link>
        <router-link to="/tools">工具</router-link>
      </div>
      <div class="footer-bottom">
        <span class="footer-copy">&copy; {{ year }} Wbxsb Blog</span>
        <p class="footer-icp">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">苏ICP备2026042783号-1</a>
          <span> · </span>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32011202001766" rel="noreferrer" target="_blank">苏公网安备32011202001766号</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BlogFooter',
  data() { return { year: new Date().getFullYear() } }
}
</script>

<style scoped>
.blog-footer {
  background: var(--blog-bg-secondary);
  border-top: 1px solid var(--blog-border);
  padding: 4rem 0 2rem;
  margin-top: 5rem;
}
.footer-inner {
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  text-align: center;
}
.footer-brand {
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--blog-text);
  margin-bottom: 0.5rem;
}
.footer-desc {
  font-size: 0.85rem;
  color: var(--blog-text-3);
  margin-bottom: 1.5rem;
}
.footer-nav {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
}
.footer-nav a {
  font-size: 0.85rem;
  color: var(--blog-text-2);
  text-decoration: none;
  transition: color 0.15s;
}
.footer-nav a:hover { color: var(--blog-accent); }
.footer-bottom {
  padding-top: 1.5rem;
  border-top: 1px solid var(--blog-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.footer-copy {
  font-size: 0.75rem;
  color: var(--blog-text-3);
}
.footer-icp { display: flex; align-items: center; gap: 0.3rem; }
.footer-icp a {
  font-size: 0.75rem;
  color: var(--blog-text-3);
  text-decoration: none;
  transition: color 0.15s;
}
.footer-icp a:hover { color: var(--blog-accent); }
.footer-icp span { font-size: 0.75rem; color: var(--blog-text-3); }

@media (max-width: 768px) {
  .footer-bottom { flex-direction: column; text-align: center; }
}
</style>
